var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "webkit-veranstaltungen-background" }, [
      _c(
        "div",
        { staticClass: "webkit-veranstaltungen-container" },
        [
          _vm._t("heading"),
          _vm._v(" "),
          _c("div", { staticClass: "webkit-veranstaltungen-container-cell" }, [
            _c(
              "div",
              { staticClass: "webkit-veranstaltungen-parent" },
              _vm._l(_vm.displayedBlocks, function(block, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "webkit-veranstaltungen-item",
                    attrs: { href: block.url || false, target: block.target }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "webkit-veranstaltungen-item-grid relative"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "webkit-veranstaltungen-date" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-auto text-f5 l:text-f5l m:text-f5m xs:text-f5xs font-bold"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(block.day) +
                                    "\n                "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-start-2 col-span-1 px-12 m:px-3 py-4"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "veranstaltungen-inner-grid" },
                              [
                                _c("div", {
                                  staticClass: "webkit-veranstaltungen-datum",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      block.day +
                                        " " +
                                        block.month +
                                        " " +
                                        block.year
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "webkit-veranstaltungen-heading",
                                  domProps: { innerHTML: _vm._s(block.heading) }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "webkit-veranstaltungen-text",
                                  domProps: { innerHTML: _vm._s(block.text) }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        block.url
                          ? _c(
                              "div",
                              { staticClass: "webkit-oneGrid-button-cell" },
                              [_vm._m(0, true)]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "webkit-veranstaltungen-load-more-button-container"
            },
            [
              _vm.blocks.length > _vm.numberOfItemsToDisplayOverview &&
              _vm.loadmorelink == ""
                ? _c(
                    "div",
                    {
                      staticClass: "flex mr-4 webkit-btn__big mb-3",
                      on: { click: _vm.showMore }
                    },
                    [
                      _vm.loadmorebutton
                        ? _c("span", {}, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.loadmorebutton) +
                                "\n          "
                            )
                          ])
                        : _c("i", { staticClass: "webkit-plus" })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loadmorelink && _vm.loadmorelink != ""
                ? _c(
                    "a",
                    {
                      staticClass: "flex mr-4 webkit-btn__big mb-3",
                      attrs: { href: _vm.loadmorelink }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.loadmorebutton) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "webkit-btn__big mb-3",
                  attrs: { href: _vm.email }
                },
                [_vm._v("\n          Veranstaltung melden\n        ")]
              )
            ]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "webkit-veranstaltungen-button" }, [
      _c("i", { staticClass: "webkit-btn__small webkit-arrow-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }